

export default {


    created() {

        let t = this;

        t.minDate = new Date(2023, 10, 1);
        t.maxDate = new Date();

        t.maxDate.setDate(t.maxDate.getDate() + 365);

        t.v.date = (new Date()).format('yyyy-MM-dd');

        t.list.country = window['COUNTRY_LIST'];

        t.list.country.forEach(item => {
            item.icon = 'assets/img/flag/' + item.code + '.svg';
        });

        let arr = [];
        t.list.country.forEach(item => {
            if (item.code != 'jp') {
                arr.push(item);
            }
        });
        t.list.country2 = arr;

        t.dict.country = listToDict(t.list.country, 'code');

        t.list.gender = [
            { id: 1, text: t.t('男') },
            { id: 2, text: t.t('女') },
            { id: 3, text: t.t('LGBTQ') },
        ];

        t.dict.gender = listToDict(t.list.gender);

        t.list.lang = [
            { id: 1, text: '日本人' },
            { id: 2, text: '「在留カード」を持ち外国人' },
            { id: 3, text: 'English' },
            { id: 4, text: '中文' },
            { id: 5, text: '한국어' },
        ];

        t.dict.lang = listToDict(t.list.lang);

        t.list.status = [
            { id: 1, text: t.t('Unconfirmed') },
            { id: 2, text: t.t('Confirmed') },
        ];

        t.dict.status = listToDict(t.list.status);

        document.addEventListener('keydown', function (event) {
            if (t.isEditing) return;

            if (event.key === 'ArrowLeft') {
                t.minusDate();
            } else if (event.key === 'ArrowRight') {
                t.plusDate();
            }

            if (event.key === 'p' || event.key === 'P') {
                window.print();
            }
        });

        t.onceP = getURLParams();

        t.loadData();

    },
    activated() {

        let t = this;

    },
    methods: {

        sendPasswordEmail(form) {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            axios.post('form/sendPasswordEmail/' + form.id).then(res => {

                t.busying = false;

                if (res.data.status == 1) {
                    form.email_status = 3;
                    A.toast('送信完了');
                }
                else {
                    A.err('メール送信に失敗しました');
                }
            });

        },

        uploadPassport(item) {
            let t = this;

            if (!item || t.busying) {
                return;
            }

            if (!t.isEditing && t.form && t.form.is_new == 1) {
                t.enterEditMode();
            }

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                compressImg(file, { max_height: 1000, max_width: 1000 }, function (base64, canvas) {
                    canvas.toBlob((blob) => {

                        let fd = new FormData();
                        fd.append('image', blob);

                        t.busying = true;
                        t.passportLoading = true;

                        axios.post('form/validatePassport', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                            if (res.data.status == 1) {
                                let passportData = res.data.options.data;
                                if (passportData) {
                                    let data = Array.isArray(passportData) ? passportData[0] : passportData;
                                    if (data) {
                                        item.passport_url = res.data.options.img_url;
                                        item.passport_data = data;
                                        t.applyPassportData(item, data);
                                    }
                                }
                            }
                            else {
                                A.err('アップロードしたパスポート写真は正しく認識できませんでした。');
                            }
                        }).catch((err) => {
                            console.error(err);
                            A.err('アップロードしたパスポート写真は正しく認識できませんでした。');
                        }).finally(() => {
                            t.busying = false;
                            t.passportLoading = false;
                        });
                    }, 'image/jpeg', 1)
                });

                event.target['value'] = '';
            };

            ImageUploader.openSelector();
        },

        recognizePassport(item) {
            let t = this;

            if (!item || !item.passport_url || t.busying) {
                return;
            }

            if (!t.isEditing && t.form && t.form.is_new == 1) {
                t.enterEditMode();
            }

            t.busying = true;
            t.passportLoading = true;

            axios.post('form/recognizePassport', { img_url: item.passport_url }).then(res => {
                if (res.data.status == 1) {
                    let passportData = res.data.options.data;
                    if (passportData) {
                        let data = Array.isArray(passportData) ? passportData[0] : passportData;
                        if (data) {
                            item.passport_data = data;
                            t.applyPassportData(item, data);
                        }
                    }
                }
                else {
                    A.err('アップロードしたパスポート写真は正しく認識できませんでした。');
                }
            }).catch((err) => {
                console.error(err);
                A.err('アップロードしたパスポート写真は正しく認識できませんでした。');
            }).finally(() => {
                t.busying = false;
                t.passportLoading = false;
            });
        },

        applyPassportData(item, data) {
            if (!item || !data) {
                return;
            }

            let name = data.name || data.nameEn || '';
            if (name) {
                item.name = name.replace(', ', ' ');
            }

            let birthday = this.parsePassportBirthday(data.birthDateYmd, data.birthDate);
            if (birthday) {
                item.birthday = birthday;
            }

            if (data.passportNumber) {
                item.passport_no = data.passportNumber;
            }

            let country = data.nationality;
            if (country) {
                if (country == 'DEUTSCH')
                    country = 'DEU';
                item.country = this.mapPassportCountry(country);
            }

            if (data.nationality == 'IND') {
                item.name = data.nameEn + ' ' + data.givenName;
            }

            if (data.nationality == 'SAU') {
                item.name = data.surname + ' ' + data.givenName;
            }

            if (data.nationality == 'RCK') {
                item.name = data.surname + ' ' + data.givenName;
            }

            this.$forceUpdate();
        },

        parsePassportBirthday(birthDateYmd, birthDate) {
            if (birthDateYmd) {
                let m = String(birthDateYmd).match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
                if (m) {
                    return m[1] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[3]).slice(-2);
                }
            }

            if (birthDate) {
                let s = String(birthDate).replace(/\D/g, '');
                if (s.length === 6) {
                    let yy = parseInt(s.slice(0, 2), 10);
                    let mm = s.slice(2, 4);
                    let dd = s.slice(4, 6);
                    let currentYy = new Date().getFullYear() % 100;
                    let year = yy > currentYy ? (1900 + yy) : (2000 + yy);
                    return year + '-' + mm + '-' + dd;
                }
                if (s.length === 8) {
                    return s.slice(0, 4) + '-' + s.slice(4, 6) + '-' + s.slice(6, 8);
                }
            }

            return '';
        },

        mapPassportCountry(passportCountry) {
            if (!passportCountry) {
                return '';
            }

            let key = String(passportCountry).trim().toUpperCase();
            let list = this.list.country || [];
            for (let i = 0; i < list.length; i++) {
                let item = list[i];
                if (item.passport && String(item.passport).toUpperCase() === key) {
                    return item.code;
                }
            }
            return '';
        },

        printA3() {
            if (window._printStyleTag) window._printStyleTag.remove();
            let style = "@media print { @page {  size: A3 portrait !important; }}";

            let s = document.createElement("style");
            s.innerHTML = style;
            document.body.appendChild(s);
            window._printStyleTag = s;
            window.print();
        },

        printA4() {
            if (window._printStyleTag) window._printStyleTag.remove();
            let style = "@media print { @page {  size: A4 portrait !important; }}";

            let s = document.createElement("style");
            s.innerHTML = style;
            document.body.appendChild(s);
            window._printStyleTag = s;
            window.print();
        },

        loadData() {
            let t = this;

            axios.get('room').then(res => {
                if (res.data.status == 1) {
                    t.list.room = res.data.options.items;
                    t.dict.room = listToDict(t.list.room);
                    axios.get('group').then(res => {
                        if (res.data.status == 1) {
                            let arr = res.data.options.items;
                            arr.forEach(group => {
                                group.expanded = true;
                                group.rooms = [];
                                let roomIds = group.room_ids.split(',');
                                roomIds.forEach(roomId => {
                                    if (t.dict.room[roomId]) {
                                        t.dict.room[roomId].group = group;
                                        group.rooms.push(t.dict.room[roomId]);
                                    }
                                });
                            });

                            t.list.group = arr;

                            t.selectRoom(t.list.room[0]);
                        }
                    });


                }
            });
        },

        onSelectDate(d) {

            let t = this;

            let date = d.format('yyyy-MM-dd');

            if (t.v.date == date)
                return;

            t.v.date = date;

            t.showDatePopover = false;

            t.loadForm();
        },

        selectRoom(room) {
            let t = this;

            if (room == t.v.room)
                return;

            t.v.room = room;
            t.v.group = room.group;

            t.showRoomPopover = false;

            t.loadForm();
        },

        cleanStatusText(status) {
            let n = Number(status);
            if (n === 1) return '未開始';
            if (n === 2) return '清掃中';
            if (n === 3) return '完了';
            if (n === 99) return '未割当';
            if (status === null || status === undefined || status === '') return '';
            return String(status);
        },

        loadForm() {

            let t = this;

            t.exitEditMode(false);
            t.ownerStay = null;
            t.form = null;

            axios.get('form/byDate/' + t.v.date + '?room_id=' + t.v.room.id).then(res => {
                let opt = (res.data && res.data.options) ? res.data.options : {};
                if (opt.owner_stay) {
                    t.ownerStay = opt.owner_stay;
                    t.form = null;
                    return;
                }
                t.form = opt.item;
                if (t.form) {

                    t.form.people_items = [];
                    if (t.form.people_data)
                        t.form.people_items = JSON.parse(t.form.people_data);

                    t.normalizeBirthdayFields();

                    t.passportUploader.items2 = [];

                    if (t.form.rc_urls) {
                        let urls = t.form.rc_urls.split(',');

                        t.passportUploader.items2 = [];
                        urls.forEach(url => {
                            t.passportUploader.items2.push(({ success: true, img_url: url, validation: false }));
                        });
                    }

                    t.passportUploader.items = [];

                    if (t.form.passport_urls) {
                        let urls = t.form.passport_urls.split(',');
                        let passportData = JSON.parse(t.form.passport_data);

                        t.passportUploader.items = [];

                        let i = 0;
                        urls.forEach(url => {
                            let data = passportData[i];
                            t.passportUploader.items.push(({ success: true, data: data, img_url: url, validation: true }));
                            i++;
                        });
                    }

                    if (t.v.room.static_password && t.v.room.static_password != 'AUTO') {
                        t.form.realPassword = t.v.room.static_password;
                    }
                    else {
                        if (t.form.door_password == 'ADMIN_PWD') {
                            t.form.realPassword = t.v.room.admin_password;
                        }
                        else {
                            t.form.realPassword = t.form.door_password.indexOf('#') > -1 ? t.form.door_password : (t.form.door_password + '#');
                        }
                    }
                }
            });

        },

        normalizeBirthday(val) {
            if (!val) return '';
            return String(val).replace(/\//g, '-').substr(0, 10);
        },

        normalizeBirthdayFields() {
            let t = this;
            if (!t.form) return;
            t.form.birthday = t.normalizeBirthday(t.form.birthday);
            (t.form.people_items || []).forEach(p => {
                p.birthday = t.normalizeBirthday(p.birthday);
            });
        },

        getEditSnapshot() {
            let t = this;
            return {
                name: t.form.name,
                passport_no: t.form.passport_no,
                birthday: t.form.birthday,
                country: t.form.country,
                dcode: t.form.dcode,
                tel: t.form.tel,
                email: t.form.email,
                local_address: t.form.local_address,
                people_items: JSON.parse(JSON.stringify(t.form.people_items || [])),
            };
        },

        enterEditMode() {
            let t = this;
            if (!t.form || t.form.is_new != 1) return;
            t.normalizeBirthdayFields();
            t.editSnapshot = t.getEditSnapshot();
            t.peopleCountryPopover = {};
            (t.form.people_items || []).forEach((_, i) => {
                t.$set(t.peopleCountryPopover, i, false);
            });
            t.showFormCountryPopover = false;
            t.isEditing = true;
        },

        exitEditMode(restore) {
            let t = this;
            if (restore && t.editSnapshot && t.form) {
                t.form.name = t.editSnapshot.name;
                t.form.passport_no = t.editSnapshot.passport_no;
                t.form.birthday = t.editSnapshot.birthday;
                t.form.country = t.editSnapshot.country;
                t.form.dcode = t.editSnapshot.dcode;
                t.form.tel = t.editSnapshot.tel;
                t.form.email = t.editSnapshot.email;
                t.form.local_address = t.editSnapshot.local_address;
                t.form.people_items = JSON.parse(JSON.stringify(t.editSnapshot.people_items || []));
            }
            t.isEditing = false;
            t.editSnapshot = null;
            t.showFormCountryPopover = false;
            t.peopleCountryPopover = {};
        },

        cancelEdit() {
            this.exitEditMode(true);
        },

        saveEdit() {
            let t = this;

            if (t.busying || !t.form) return;

            t.busying = true;

            let data = {
                id: t.form.id,
                name: t.form.name,
                passport_no: t.form.passport_no,
                birthday: t.form.birthday,
                country: t.form.country,
                dcode: t.form.dcode,
                tel: t.form.tel,
                email: t.form.email,
                local_address: t.form.local_address,
                people_data: JSON.stringify(t.form.people_items || []),
            };

            axios.post('form/update', data).then(res => {
                t.busying = false;
                if (res.data.status == 1) {
                    A.toast('更新完了');
                    t.exitEditMode(false);
                    t.loadForm();
                } else {
                    A.err(res.data.msg || '更新に失敗しました');
                }
            }).catch(() => {
                t.busying = false;
                A.err('更新に失敗しました');
            });
        },

        isFormDirty(field) {
            let t = this;
            if (!t.isEditing || !t.editSnapshot) return false;
            return String(t.form[field] == null ? '' : t.form[field]) !== String(t.editSnapshot[field] == null ? '' : t.editSnapshot[field]);
        },

        isPeopleDirty(i, field) {
            let t = this;
            if (!t.isEditing || !t.editSnapshot || !t.editSnapshot.people_items || !t.editSnapshot.people_items[i]) return false;
            let cur = t.form.people_items[i] ? t.form.people_items[i][field] : '';
            let old = t.editSnapshot.people_items[i][field];
            return String(cur == null ? '' : cur) !== String(old == null ? '' : old);
        },

        onSelectFormCountry(item) {
            this.form.country = item.code;
            this.showFormCountryPopover = false;
        },

        onSelectPeopleCountry(item, p, i) {
            p.country = item.code;
            this.$set(this.peopleCountryPopover, i, false);
        },

        deleteForm() {

            let t = this;
            Swal.mixin({
                customClass: {
                    confirmButton: 'btn-lg btn-orange',
                    cancelButton: 'btn-sm btn-dark mr10'
                },
                confirmButtonText: 'はい',
                cancelButtonText: 'いいえ',
                buttonsStyling: false,
                showCancelButton: true
            }).fire('データーを削除', "よろしいですか。", 'warning').then(res => {
                if (res.isConfirmed) {
                    axios.post('form/delete', { id: t.form.id }).then(res => {
                        t.loadData();
                    });
                }
            });

        },

        minusDate() {
            let t = this;

            let d = new Date(t.v.date.replace(/-/g, '/'));
            d.setDate(d.getDate() - 1);

            t.v.date = d.format('yyyy-MM-dd');

            t.loadForm();

            t.stopPropagation();
        },

        plusDate() {
            let t = this;

            let d = new Date(t.v.date.replace(/-/g, '/'));
            d.setDate(d.getDate() + 1);

            t.v.date = d.format('yyyy-MM-dd');

            t.loadForm();

            t.stopPropagation();
        }

    },
    data() {
        return {

            keywordSearch: {
                room_name: ''
            },

            onceP: {},
            signIned: false,
            form: null,
            ownerStay: null,
            isEditing: false,
            editSnapshot: null,
            busying: false,
            passportLoading: false,
            showFormCountryPopover: false,
            peopleCountryPopover: {},
            v: {
                date: '',
                room: null,
                group: null,
            },
            list: {
                room: [],
                group: [],
                country: [],
                country2: [],
                gender: [],
                lang: [],
                status: []
            },

            dict: {
                room: {},
                group: {},
                country: {},
                gender: {},
                lang: {},
                status: {}
            },

            showRoomPopover: false,
            showDatePopover: false,

            minDate: null,
            maxDate: null,

            passportUploader: {
                current: null,
                items: [
                ],
                items2: []
            },
        };
    },
    computed: {
        filteredRooms() {
            let t = this;

            let arr = [];

            t.list.room.forEach(item => {
                if (t.keywordSearch.room_name && (item.name.indexOf(t.keywordSearch.room_name) > -1)) {
                    arr.push(item);
                }
            });

            return arr;
        },

        selectedRooms() {
            let t = this;

            let arr = [];

            t.list.room.forEach(item => {
                if (item.selected) {
                    arr.push(item);
                }
            });

            return arr;
        },
    }
};
